import { Client, GraphRequestOptions, PageCollection, PageIterator } from '@microsoft/microsoft-graph-client';
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import { zonedTimeToUtc } from 'date-fns-tz';
import {Event, User } from 'microsoft-graph';
import { setUserId} from 'firebase/analytics';
import { GoogleAnalytics } from './App';
import { ExcelClinicInfo } from './common/types';
import { fetchAndParseExcelClinicData } from './common/excel_as_database/ExcelClinicsController';

let graphClient: Client | undefined = undefined;

function ensureClient(authProvider: AuthCodeMSALBrowserAuthenticationProvider) {
  if (!graphClient) {
    graphClient = Client.initWithMiddleware({
      authProvider: authProvider
    });
  }

  return graphClient;
}

export function isSignedIn(){
  return graphClient!==undefined
}
export async function getUser(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<User> {
  ensureClient(authProvider);

  // Return the /me API endpoint result as a User object
  let user: User = await graphClient!.api('/me')
    // Only retrieve the specific fields needed
    .select('displayName,mail,id')
    .get();

    //ASSUMED USER BASED ON LACK OF PERMISSIONS
    //@ts-ignore //TODOSCALING need to request mailboxSettings to allow timezone and time format preferences
    user.mailboxSettings = {}
    user.mailboxSettings.timeZone ="Eastern Standard Time";
    user.mailboxSettings.timeFormat = "h:mm a";

    setUserId(GoogleAnalytics, user.id || "No-user-id")
  return user;
}

export async function getUserCalendar(
  authProvider: AuthCodeMSALBrowserAuthenticationProvider,
  timeZone: string,
  startDate: string| number| Date,
  endDate: string| number| Date
  ): Promise<Event[]> {
  ensureClient(authProvider);

  // Generate startDateTime and endDateTime query params
  // to display a window of time
  const startDateTime = zonedTimeToUtc(startDate,timeZone).toISOString();
  const endDateTime = zonedTimeToUtc(endDate, timeZone).toISOString();

  // GET /me/calendarview?startDateTime=''&endDateTime=''
  // &$select=subject,organizer,start,end
  // &$orderby=start/dateTime
  // &$top=50
  var response: PageCollection = await graphClient!
    .api("/me/calendarview")
    .header("Prefer", `outlook.timezone="${timeZone}"`)
    .query({ startDateTime: startDateTime, endDateTime: endDateTime })
    .select("subject,bodyPreview,start,end")
    .orderby("start/dateTime")
    .top(10000)
    .get();

  if (response["@odata.nextLink"]) {
    // Presence of the nextLink property indicates more results are available
    // Use a page iterator to get all results
    var events: Event[] = [];

    // Must include the time zone header in page
    // requests too
    var options: GraphRequestOptions = {
      headers: { Prefer: `outlook.timezone="${timeZone}"` },
    };

    var pageIterator = new PageIterator(
      graphClient!,
      response,
      (event) => {
        events.push(event);
        return true;
      },
      options
    );

    await pageIterator.iterate();

    return events;
  } else {
    return response.value;
  }
}

export async function getSpecialtyClinicsData(authProvider: AuthCodeMSALBrowserAuthenticationProvider): Promise<ExcelClinicInfo[]>{
  ensureClient(authProvider);
  return fetchAndParseExcelClinicData(graphClient!)
}

